import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { SectionGroup } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { BulkAddRowsFieldSection } from 'Components/Worksheets/DynamicConePenetrometerWorksheet/Shared/BulkAddRowsFieldSection';
import { actions } from 'Data/ReduxViewModels/WorksheetEditor';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import { MeasurementGridFieldSection } from './MeasurementGridFieldSection';

type IResultNotObtainableDependant = IWorksheetComponent & {
  children: any;
  disabled: boolean;
  visible: boolean;
};

let MeasurementCalculationSection: React.FC<IResultNotObtainableDependant> = ({
  children,
  disabled,
  visible,
  createWorksheetSelector,
  prefixName,
}) => {
  const dispatch = useDispatch();
  const measurementCount = useSelector(
    pipe(createWorksheetSelector!('Measurements'), valueOrDefault([]), (measurements) => measurements.length)
  );
  const handleAddRowsClick = (rowsToAdd: number) => {
    dispatch(
      actions.addArrayEntry({
        name: prefixName!('Measurements'),
        index: rowsToAdd + measurementCount - 1,
        sync: true,
      })
    );
  };
  return (
    <>
      <SectionGroup visible={visible}>
        <MeasurementGridFieldSection disabled={disabled} />
        {children}
      </SectionGroup>
      <BulkAddRowsFieldSection visible={visible} onClick={handleAddRowsClick} disabled={disabled} />
    </>
  );
};

MeasurementCalculationSection = withInjectedProps(MeasurementCalculationSection);
export { MeasurementCalculationSection };
export default MeasurementCalculationSection;
